__turbopack_context__.v({
  "apple": "_4lPckW_apple",
  "content": "_4lPckW_content",
  "default": "_4lPckW_default",
  "disabled": "_4lPckW_disabled",
  "firebase": "_4lPckW_firebase",
  "google": "_4lPckW_google",
  "shimmer": "_4lPckW_shimmer",
  "text-bar-sweep": "_4lPckW_text-bar-sweep",
});
